import { VALUE_TYPES } from "@/static/valueTypes";
import { AttributePrototype } from "@/models/api/administration/servicesAndAttributes/AttributePrototype";
import { Translation } from "@/models/api/Translation";

export class AttributePrototypeAddEdit {
  code!: string;
  defaultLabel!: string | null;
  defaultValueType!: VALUE_TYPES;
  attributeSource!: string | null;
  valueToUpper!: boolean;
  attributeTranslations!: Array<Translation>;
  constructor() {
    this.code = "";
    this.defaultLabel = "";
    this.defaultValueType = VALUE_TYPES.Unknown;
    this.attributeSource = "";
    this.attributeTranslations = [];
    this.valueToUpper = false;
  }

  static fromAttributePrototype(attributePrototype: AttributePrototype): AttributePrototypeAddEdit {
    const attributePrototypeAddEdit = new AttributePrototypeAddEdit();
    attributePrototypeAddEdit.code = attributePrototype.code;
    attributePrototypeAddEdit.attributeSource = attributePrototype.attributeSource;
    attributePrototypeAddEdit.defaultLabel = attributePrototype.defaultLabel;
    attributePrototypeAddEdit.defaultValueType = attributePrototype.defaultValueType;
    attributePrototypeAddEdit.valueToUpper = attributePrototype.valueToUpper;
    attributePrototypeAddEdit.attributeTranslations = attributePrototype.attributeTranslations.map((v) => ({
      name: v.name,
      cultureId: v.cultureId,
    }));
    return attributePrototypeAddEdit;
  }
}
